var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankDetailsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EBEDEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 24C30.75 24.4142 30.4142 24.75 30 24.75C29.5858 24.75 29.25 24.4142 29.25 24C29.25 23.5858 29.5858 23.25 30 23.25C30.4142 23.25 30.75 23.5858 30.75 24Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.02 21H32.98M25.5 24H27.5M22.2 32H25.8C28.7998 32 30.2997 32 31.3511 31.2361C31.6907 30.9893 31.9893 30.6907 32.2361 30.3511C33 29.2997 33 27.7998 33 24.8V23.2C33 20.2002 33 18.7003 32.2361 17.6489C31.9893 17.3093 31.6907 17.0107 31.3511 16.7639C30.2997 16 28.7998 16 25.8 16H22.2C19.2002 16 17.7003 16 16.6489 16.7639C16.3093 17.0107 16.0107 17.3093 15.7639 17.6489C15 18.7003 15 20.2002 15 23.2V24.8C15 27.7998 15 29.2997 15.7639 30.3511C16.0107 30.6907 16.3093 30.9893 16.6489 31.2361C17.7003 32 19.2002 32 22.2 32Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankDetailsGrey);
export default __webpack_public_path__ + "static/media/bank_details_grey.558e83351d76c1fe3d9b1b5eb39ed6c0.svg";
export { ForwardRef as ReactComponent };